var pug = require("!../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_debug_filename, pug_debug_line;try {var pug_debug_sources = {"\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug":"mixin unified(slot)\n  td(colspan=\"2\")\n    p.Schedule-title!= slot.title\n\nmixin timeSlot(slot)\n  tr\n    td.Schedule-time= slot.time\n    +unified(slot.unified)\n\nmixin dayTable(day)\n  table.Schedule.hover.scroll\n    colgroup\n      col\n      col(style=\"width:50%\")\n      col(style=\"width:50%\")\n    tbody\n      each slot in day.slots\n        +timeSlot(slot)\n\nh1 Significant Other Track\n\np TBA\n"};
;pug_debug_line = 1;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_mixins["unified"] = pug_interp = function(slot){
var block = (this && this.block), attributes = (this && this.attributes) || {};
;pug_debug_line = 2;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "\u003Ctd colspan=\"2\"\u003E";
;pug_debug_line = 3;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "\u003Cp class=\"Schedule-title\"\u003E";
;pug_debug_line = 3;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + (null == (pug_interp = slot.title) ? "" : pug_interp) + "\u003C\u002Fp\u003E\u003C\u002Ftd\u003E";
};
;pug_debug_line = 5;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_mixins["timeSlot"] = pug_interp = function(slot){
var block = (this && this.block), attributes = (this && this.attributes) || {};
;pug_debug_line = 6;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "\u003Ctr\u003E";
;pug_debug_line = 7;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "\u003Ctd class=\"Schedule-time\"\u003E";
;pug_debug_line = 7;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + (pug.escape(null == (pug_interp = slot.time) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
;pug_debug_line = 8;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_mixins["unified"](slot.unified);
pug_html = pug_html + "\u003C\u002Ftr\u003E";
};
;pug_debug_line = 10;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";



























;pug_debug_line = 20;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "\u003Ch1\u003E";
;pug_debug_line = 20;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "Significant Other Track\u003C\u002Fh1\u003E";
;pug_debug_line = 22;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "\u003Cp\u003E";
;pug_debug_line = 22;pug_debug_filename = "\u002Fhome\u002Ftravis\u002Fbuild\u002Fjsis\u002Fjsconf.is\u002Fpages\u002F_schedule.pug";
pug_html = pug_html + "TBA\u003C\u002Fp\u003E";} catch (err) {pug.rethrow(err, pug_debug_filename, pug_debug_line, pug_debug_sources[pug_debug_filename]);};return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./_schedule.pug
// module id = 489
// module chunks = 0